<template>
  <div ref="list" v-show="!showCheckList">
    <div
      class="hideOnScroll filter"
      ref="hideOnScroll"
      v-if="!isOneServiceCall"
    >
      <p-vue-input-text
        type="text"
        class="phone-number search"
        v-model="search"
        :placeholder="__('search')"
        @input="searchServiceCalls"
      />
      <a href="#" @click.prevent="filterModal = true">
        <i-icon name="filter" />
      </a>
    </div>
    <div
      class="service-calls-list"
      :class="{
        'add-margin': !isOneServiceCall,
        building: BID,
        'one-service-call': isOneServiceCall,
      }"
      v-if="serviceCalls?.length > 0"
    >
      <local-service-call
        v-for="(serviceCall, index) of serviceCallsFiltered"
        :key="index"
        :serviceCall="serviceCall"
        :showServiceCall="true"
        @showServiceCallData="showServiceCallData"
        @refreshServiceCall="refreshServiceCall"
        @getTranslatedSubject="getTranslatedSubject"
        @showCheckList="showCheckListToProblem"
        @DeleteServiceCall="DeleteServiceCall"
      ></local-service-call>
    </div>
    <h1 class="no-data add-margin" v-else-if="serviceCalls">
      {{ __("There are no service calls for the building") }}
    </h1>
  </div>
  <i-override-dialog
    v-model:visible="showModel"
    :style="{
      width: '100%',
      maxWidth: 'calc(100vw - 10px)',
    }"
    :modal="true"
    :dismissableMask="true"
    :title="__('Add') + ' ' + __('Service call')"
  >
    <local-add-service-call
      :serviceCall="{ BID: BID }"
      @serviceCallChanged="serviceCallChanged"
      :close="
        () => {
          showModel = false;
        }
      "
    ></local-add-service-call>
  </i-override-dialog>
  <i-plus-button @click="showModel = true" v-show="!showCheckList" />
  <p-vue-sidebar
    position="left"
    class="sidebar--menu"
    id="apartments-and-tenants-filter"
    :style="{
      padding: 0,
      maxWidth: '275px',
    }"
    v-model:visible="filterModal"
  >
    <local-filter
      :filters="filters"
      @filter="getServiceCalls"
      @sort="sortServiceCalls"
      @changeFiltersData="changeFiltersData"
      :close="() => (filterModal = false)"
    />
  </p-vue-sidebar>
  <local-chapters-list
    class="p-p-3"
    v-if="showCheckList"
    :mtcCheckListID="serviceCallSelected.mtcCheckListID"
    :PID="serviceCallSelected.PID"
    :BID="serviceCallSelected.BID"
    :problemSubject="serviceCallSelected.Subject"
    @refreshServiceCall="refreshServiceCall"
    @closeCheckList="$store.commit('setShowCheckList', false)"
  ></local-chapters-list>
</template>

<script>
import { mapState } from "vuex";
import LocalFilter from "./filter";
import {
  callProc,
  apiParam,
  apiPType,
  TranslateProblem,
} from "@/services/APointAPI";
import { sort_array_by_field } from "@/services/apointUtil";
// import { HideOnScroll } from "@/services/Scroll";
import LocalServiceCall from "./service-call";
import { ServiceCallActions } from "@/configs/enums";
import LocalAddServiceCall from "./add-service-call";
import { errorReceived } from "@/services/apointUtil";
import { __ } from "@/plugins/i18n/";
import LocalChaptersList from "./check-list/chapters-list";
import { getWorkerData } from "@/services/service";

export default {
  components: {
    LocalFilter,
    LocalServiceCall,
    LocalAddServiceCall,
    LocalChaptersList,
  },
  data() {
    return {
      BID: this.$route.params.bid,
      serviceCalls: null,
      serviceCallsFiltered: [],
      search: null,
      lastScrollTop: 0,
      showModel: false,
      serviceCallSelected: {},
      filterModal: false,
      filters: {},
      PID: this.$route.params.pid,
      strTblStatus: null,
    };
  },
  mounted() {
    // setTimeout(() => {
    //   HideOnScroll(document.querySelector(".page"), this.$refs.hideOnScroll);
    // }, 2000);

    // if (!this.userNum)
    getWorkerData().then(() => this.getSearchData());
    // else this.getSearchData();

    this.$store.commit("setShowCheckList", false);
    this.search = this.serviceCallsSearch;
  },
  methods: {
    getSearchData() {
      this.$store.dispatch("doLoading", true);
      let procParams = [apiParam("UserNum", this.userNum, apiPType.Int)];
      callProc("WorkerApp_ListProblemsSearchData", procParams)
        .then((result) => {
          result = JSON.parse(result);
          // console.log(result);
          this.filters = {
            defaultStatus: result.Table[0].defaultStatus,
            defaultTypeFilter: result.Table[0].defaultTypeFilter,
            strTblStatusOption: result.Table1,
            enableHomeSvcCalls: result.Table2[0].enableHomeSvcCalls,
            showHomeSvcCallsOption: [
              { label: __("General to the house"), value: true },
              { label: __("General"), value: false },
            ],
            showRulesOption: [
              { label: __("No"), value: false },
              { label: __("Yes"), value: true },
            ],
            reportTypesOptions: result.Table3,
            workersOptions: result.Table4,
            worker: null,
            openingDate: null,
            priorityOptions: result.Table5,
            priority: null,
            order: this.serviceCallsOrder,
            strTblStatus: this.strTblStatus,
            filterStatus: result.Table[0].defaultStatus,
            filterTypeFilter: result.Table[0].defaultTypeFilter,
          };
          this.filters.showHomeSvcCallsOption[0].label =
            result.Table2[0].HomeSvcCallsDesc;
          this.filters.showHomeSvcCalls = this.filters.showHomeSvcCallsOption[1];
          this.filters.showRules = this.filters.showRulesOption.find(
            (f) => f.value == this.showRulesServiceCall
          );
          this.getServiceCalls(
            this.filters.defaultStatus,
            this.filters.defaultTypeFilter,
            this.filters.showRules.value,
            this.filters.showHomeSvcCalls.value,
            this.filters.openingDate,
            this.filters.worker,
            this.filters.priority
          );
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_ListProblemsSearchData");
        });
    },
    getTranslatedSubject(PID, toLanguage, isOnlyShowTranslate) {
      // console.log(PID);
      const SCidx = this.serviceCalls.findIndex((SC) => SC.PID === PID);
      if (SCidx < 0) return;
      let sc = this.serviceCalls[SCidx];
      if (sc.showTranslatedSubject === true) {
        sc.showTranslatedSubject = false;
      } else {
        if (isOnlyShowTranslate) {
          sc.showTranslatedSubject = true;
          return;
        }
        TranslateProblem(PID, toLanguage)
          .then((result) => {
            if (result.APIResponseCode === 0) {
              // console.log("getTranslatedSubject", result.APIResponseText);
              if (result.APIResponseText === "") {
                errorReceived(
                  __("Translation error"),
                  __("We could not translate")
                );
              } else {
                sc.showTranslatedSubject = true;
                sc.translatedSubject = result.APIResponseText;
              }
            }
          })
          .catch((e) => {
            errorReceived("getTranslatedSubject", e);
          });
      }
    },
    getServiceCalls(
      status,
      typeFilter,
      showRules,
      showHomeSvcCalls,
      reportType,
      openingDate,
      worker,
      priority
    ) {
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("UserNum", this.userNum, apiPType.Int),
        apiParam("BID", this.BID ? this.BID : null, apiPType.Int),
        apiParam("PID", this.PID ? this.PID : null, apiPType.Int),
        apiParam("Status", status, apiPType.TinyInt),
        apiParam("TypeFilter", typeFilter, apiPType.TinyInt),
        apiParam("Rules", showRules, apiPType.Bit),
        apiParam("HomeSvcCalls", showHomeSvcCalls, apiPType.Bit),
        apiParam(
          "ReportType",
          reportType ? reportType : 0,
          apiPType.TinyIntBit
        ),
        apiParam("openingDate", openingDate, apiPType.SmallDateTime),
        apiParam("worker", worker, apiPType.Int),
        apiParam("priority", priority, apiPType.Int),
      ];
      callProc("WorkerApp_ListProblems", procParams)
        .then((result) => {
          result = JSON.parse(result);
          this.filters.filterStatus = status;
          this.filters.filterTypeFilter = typeFilter;
          this.serviceCalls = result.Table; //.filter(f=>f.mtcCheckListID);
          // console.log(this.isOneServiceCall,this.serviceCalls,"WorkerApp_ListProblems");
          this.serviceCalls.map((serviceCall) => {
            serviceCall.action = ServiceCallActions.None;
            serviceCall.showTranslatedSubject = false;
          });
          if (this.isOneServiceCall)
            this.showServiceCallData(
              this.serviceCalls.find((f) => f.PID == this.PID),
              ServiceCallActions.View
            );
          this.filterModal = false;
          // console.log(this.serviceCalls);
          this.sortServiceCalls(this.serviceCallsOrder, "serviceCalls");
          this.serviceCallsFiltered = [];
          this.searchServiceCalls();
          this.$store.dispatch("doLoading", false);
        })
        .catch((error) => {
          console.log(error);
          errorReceived("WorkerApp_ListProblems");
        });
    },
    searchServiceCalls() {
      // this.serviceCallsFiltered = [];
      if (this.search && this.search != "" && this.serviceCalls) {
        this.serviceCallsFiltered = this.serviceCalls.filter(
          (f) =>
            f.Subject?.includes(this.search) ||
            f.BuildingName?.includes(this.search) ||
            f.ReportName?.includes(this.search) ||
            f.WorkerName?.includes(this.search) ||
            f.Company?.includes(this.search) ||
            f.PID == this.search ||
            f.ReportBy == this.search
        );
      } else {
        this.serviceCalls.forEach((srv) => {
          setTimeout(() => {
            this.serviceCallsFiltered.push(srv);
          }, 0);
        });
      }
      // this.serviceCallsFiltered = this.serviceCalls;
    },
    sortServiceCalls(order, arrayNameToSort = "serviceCallsFiltered") {
      if (!order) {
        if (this.serviceCallsOrder) order = this.serviceCallsOrder;
        else order = "DueDate";
      }
      this.$store.commit("api/setSessionData", {
        serviceCallsOrder: order,
      });
      this.filters.order = order;
      let DESC = order.includes("DESC");
      switch (order) {
        case "OpenDate":
        case "OpenDate DESC":
        case "ClosingDate":
        case "ClosingDate DESC":
        case "DueDate":
        case "DueDate DESC":
        case "LastDateUpdate":
        case "LastDateUpdate DESC":
          sort_array_by_field(
            arrayNameToSort == "serviceCallsFiltered"
              ? this.serviceCallsFiltered
              : this.serviceCalls,
            order.replace(" DESC", ""),
            DESC,
            (a) => new Date(a)
          );
          break;
        case "PID":
        case "PID DESC":
          sort_array_by_field(
            arrayNameToSort == "serviceCallsFiltered"
              ? this.serviceCallsFiltered
              : this.serviceCalls,
            "PID",
            DESC,
            (a) => parseInt(a)
          );
          break;
        case "Priority OpenDate DESC":
          // this.sort("PriorityCssClass OpenDate", true);
          // return (a.BoldReportPriority === b.BoldReportPriority)? 0 : a? -1 : 1;
          (arrayNameToSort == "serviceCallsFiltered"
            ? this.serviceCallsFiltered
            : this.serviceCalls
          ).sort((a, b) => {
            if (a.BoldReportPriority === b.BoldReportPriority) {
              return new Date(a.OpenDate) < new Date(b.OpenDate) ? 1 : -1;
            } else {
              return a.BoldReportPriority < b.BoldReportPriority ? 1 : -1;
            }
          });
          break;
      }
    },
    showServiceCallData(serviceCall, action) {
      // console.log(serviceCall);
      let lastAction = serviceCall.action;
      this.serviceCallsFiltered.map((LocalserviceCall) => {
        if (LocalserviceCall.PID != serviceCall.PID)
          LocalserviceCall.action = ServiceCallActions.None;
      });
      if (lastAction != action) serviceCall.action = action;
      else serviceCall.action = ServiceCallActions.None;
    },
    refreshServiceCall(serviceCall) {
      let index = this.serviceCalls.findIndex((f) => f.PID == serviceCall.PID);
      let index1 = this.serviceCallsFiltered.findIndex(
        (f) => f.PID == serviceCall.PID
      );
      if (index != -1) {
        this.serviceCalls[index] = serviceCall;
        this.serviceCallsFiltered[index1] = serviceCall;
      } else this.serviceCalls.push(serviceCall);
      this.$store.commit("setShowCheckList", false);
    },
    showCheckListToProblem(PID) {
      this.serviceCallSelected = this.serviceCalls.find((f) => f.PID === PID);
      this.$store.commit("setShowCheckList", true);
    },
    DeleteServiceCall(PID) {
      let index = this.serviceCalls.findIndex((f) => f.PID == PID);
      this.serviceCalls.splice(index, 1);
      this.searchServiceCalls();
    },
    serviceCallChanged(serviceCall) {
      this.showModel = false;
      this.refreshServiceCall(serviceCall);
    },
    changeFiltersData(data) {
      for (let filter in data) {
        this.filters[filter] = data[filter];
      }
    },
  },
  computed: {
    ...mapState({
      userNum: (state) => state.api.workerID,
      showCheckList: (state) => state.showCheckList,
      showRulesServiceCall: (state) => state.api.showRulesServiceCall,
      serviceCallsSearch: (state) => state.api.serviceCallsSearch,
      serviceCallsOrder: (state) => state.api.serviceCallsOrder,
    }),
    isOneServiceCall() {
      return this.$route.name == "OneServiceCall";
    },
  },
  watch: {
    search() {
      this.$store.commit("api/setSessionData", {
        serviceCallsSearch: this.search,
      });
    },
  },
};
</script>

<style scoped>
:deep(.p-panel .p-panel-icons) {
  display: block;
}

.service-calls-list:deep(.p-component) {
  font-size: 14px;
}

.filter {
  display: flex;
  justify-content: space-between;
  padding: 10px 15px 5px;
  background-color: var(--color-primary);
}

.filter a {
  color: white;
  margin-right: 3px;
}

.filter a:deep(.svg) {
  width: 24px;
  height: 24px;
}

.search {
  flex: 1;

  padding: 0 0 8px 0;

  border-radius: 0;
  border: 1px solid white;
  border-width: 0 0 1px 0;
  background-color: transparent;

  color: white;
  font-size: 16px;
  line-height: 1.28;
  font-style: italic;
  font-weight: normal;
  letter-spacing: 0.51px;
}

.search::placeholder {
  color: white;
  font-size: 16px;
  line-height: 1.28;
  font-style: italic;
  font-weight: normal;
  letter-spacing: 0.51px;
}

.add-margin {
  overflow-y: scroll;
  height: calc(100vh - 155px);
}

.add-margin.building {
  overflow-y: scroll;
  height: calc(100vh - 201px);
}

.one-service-call:deep(.p-panel .p-panel-content:last-child) {
  border: none;
}

.no-data {
  text-align: center;
  color: var(--color-success);
}
</style>
